import React, { useEffect, useRef, useState } from "react";
import { ImagePopout } from "components/image-stream/image-popout";

const MAX_HEIGHT = 500;

const EditedImage = (props) => {
    const [timestamp] = useState(new Date().getTime());
    const imageRef = useRef(null);
    const divRef = useRef(null);
    const [dimensions, setDimensions] = useState({
        width: "auto",
        height: "auto",
        ratio: 0,
        divWidth: 0,
        divHeight: 0,
        forceHeight: 547,
    });

    useEffect(() => {
        if (dimensions.ratio === 0) {
            return;
        }

        if (props.rotation === 90 || props.rotation === 270) {
            setDimensions({
                ...dimensions,
                width: dimensions.ratio < 1 ? dimensions.divHeight * dimensions.ratio : Math.max(dimensions.divHeight, MAX_HEIGHT),
                height: dimensions.ratio < 1 ? dimensions.divWidth : dimensions.divWidth / dimensions.ratio,
                forceHeight: dimensions.ratio < 1 ? dimensions.divHeight * dimensions.ratio : Math.max(dimensions.divHeight, MAX_HEIGHT),
            });
        } else {
            setDimensions({
                ...dimensions,
                width: dimensions.ratio < 1 ? dimensions.divHeight * dimensions.ratio : dimensions.divWidth,
                height: dimensions.ratio < 1 ? dimensions.divHeight : dimensions.divWidth / dimensions.ratio,
                forceHeight: dimensions.ratio < 1 ? dimensions.divHeight : dimensions.divWidth / dimensions.ratio,
            });
        }

        if (props.isIE) {
            const { width, height } = imageRef.current;

            if (props.rotation === 90 || props.rotation === 270) {
                return setDimensions({
                    ...dimensions,
                    forceHeight: dimensions.ratio > 1 && width > MAX_HEIGHT ? width : dimensions.divHeight * dimensions.ratio,
                });
            } else {
                return setDimensions({
                    ...dimensions,
                    forceHeight: dimensions.ratio > 1 ? (height < MAX_HEIGHT ? height : MAX_HEIGHT) : dimensions.divHeight,
                });
            }
        }
    }, [props.rotation]);

    const getImageSize = () => {
        const { width, height } = imageRef.current;
        const divWidth = divRef.current.offsetWidth;
        const divHeight = divRef.current.offsetHeight;
        const ratio = width / height;
        const potentialHeight = divWidth / ratio;

        setDimensions({
            width: ratio < 1 || potentialHeight > MAX_HEIGHT ? Math.min(divHeight, MAX_HEIGHT) * ratio : divWidth,
            height: ratio < 1 || potentialHeight > MAX_HEIGHT ? Math.min(divHeight, MAX_HEIGHT) : divWidth / ratio,
            ratio: ratio,
            divWidth: divWidth,
            divHeight: divHeight,
            forceHeight: ratio < 1 || potentialHeight > MAX_HEIGHT ? Math.min(divHeight, MAX_HEIGHT) : divWidth / ratio,
        });
    };

    return (
        <div
            ref={divRef}
            className={`edited-image rotate${props.rotation}`}
            style={{
                height: dimensions.forceHeight,
            }}
        >
            <ImagePopout
                photoKey={`img_${props.wipKey}_${props.shot.key}`}
                imageUris={props.shot.editedImageUris}
                shipmentKey={props.shipmentKey}
                shipmentProductKey={props.shipmentProductKey}
                alt={`Product ${props.shot.imageView}`}
                imageSize="medium"
                isEdited
                timeStamp={timestamp}
                handleOnLoad={getImageSize}
                ref={imageRef}
                styleOverrides={{
                    maxHeight: "none",
                    maxWidth: "none",
                    width: dimensions.width,
                    height: dimensions.height,
                }}
            />
        </div>
    );
};

export default EditedImage;
